import React from "react";

const AllBuyers = () => {
  return <div>This is All buyers page</div>;
};

export default AllBuyers;
